module.exports = __webpack_public_path__ + "media/state-press-2_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-2_1200.jpg
// module id = 38
// module chunks = 0